<script lang="ts">
  import { Accordion } from "@/Common";
    import { defaultTrainingPlanSettings, type AllXataPlans } from "@/Common/constants";
    import { PolarizationSlider, RecoverySlider } from "./SetupFormInputs";
    import type { Writable } from "svelte/store";
    import {InfoIcon} from "@/Common";
    import { bootstrapConfirmation } from "@/Bootstrap";

    export let plan: Writable<AllXataPlans>
    export let disabled = false
    export let onInput = () => {}
    let className = ""
    export {className as class}

    function resetToDefaults() {
        $plan.settings = {
            ...$plan.settings,
            polarization: defaultTrainingPlanSettings.polarization,
            recovery: defaultTrainingPlanSettings.recovery,
        }
    }

</script>

<div class={className}>
    <Accordion class="py-2 px-4 border border-solid border-black/10 rounded">
        <div slot="trigger" class="text-slate-600 text-left">General Settings</div>
        <div slot="content" class="grid grid-cols-[1fr,3fr] auto-rows-max items-start gap-y-9 gap-x-3 md:gap-x-6 md:text-right text-left text-base">

            <span class="text-slate-600 text-sm">Polarization Level <InfoIcon href={`https://baronbiosys.com/glossary/polarization-level/`}/></span>
            <PolarizationSlider {disabled}
                bind:polarization={$plan.settings.polarization}
                onInput={onInput}
            />

            <span class="text-slate-600 text-sm">Recovery Demands <InfoIcon href={`https://baronbiosys.com/glossary/recovery-demands/`}/></span>
            <RecoverySlider {disabled}
                bind:recovery={$plan.settings.recovery}
                onInput={onInput}
            />

            <button 
                use:bootstrapConfirmation={{
                    onclick: resetToDefaults,
                    placement: "top",
                    okMessage: "Reset",
                    cancelMessage: "Cancel",
                    title: "Restore General Settings to Xert Defaults ?",
                }} 
                class="btn-xfai-sm border-0 text-xerteal-500 hover:underline bg-transparent col-span-2 justify-self-end" type="button"
            >
                Defaults
            </button>
        </div>
    </Accordion>
</div>